import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ 
    "addButton", "template", "list"
   ];

    connect()
    {
        this.addButtonTarget.addEventListener("click", e =>
        {
            e.preventDefault();
        })

        this.addButtonTarget.addEventListener("click", e => {
            this.listTarget.appendChild(this.templateTarget.content.cloneNode(true));
        })
    }

    clearTestDetails(e)
    {
        this.listTarget.innerHTML = "";
    }
}